/*
 * @Author: your name
 * @Date: 2021-02-03 19:26:03
 * @LastEditTime: 2021-05-08 09:44:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fe-mall/pages/index/src/router/requisition.js
 */
export default {
  fixed: [
    // 我的领用单详情
    {
      path: '/requisition/info',
      name: 'requisition-detail',
      component: () => import(/* webpackChunkName: "requisition-detail" */'../routes/requisition/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '领用单详情',
          en: '领用单详情_en',
          jp: '领用单详情_jp'
        },
        spmB: 'b22',
        isNewHeader: true,
        i18nCode: 'requisition/detail',
        menuCode: '/requisition/list'
      }
    },
    // 我的利旧单详情
    {
      path: '/benefitforold/info',
      name: 'benefitforold-info',
      component: () => import(/* webpackChunkName: "benefitforold-info" */'../routes/requisition/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '利旧单详情',
          en: '利旧单详情_en',
          jp: '利旧单详情_jp'
        },
        spmB: 'b440',
        i18nCode: 'requisition/detail',
        isNewHeader: true,
        menuCode: '/recycle/list'
      }
    },
    // 我的领用单详情
    {
      path: '/requisition/edit',
      name: 'requisitionEdit',
      component: () => import(/* webpackChunkName: "requisitionEdit" */'../routes/requisition/edit/index.vue'),
      meta: {
        // title: '编辑领用申请单',
        title: {
          'zh-CN': '编辑领用申请单',
          en: '编辑领用申请单_en',
          jp: '编辑领用申请单_jp'
        },
        spmB: 'b23',
        isNewHeader: true,
        i18nCode: 'requisition/edit',
        menuCode: '/requisition/list'
      }
    },
    {
      path: '/recycle/edit',
      name: 'recycleEdit',
      component: () => import(/* webpackChunkName: "recycleEdit" */'../routes/requisition/edit/index.vue'),
      meta: {
        // title: '编辑领用申请单',
        title: {
          'zh-CN': '编辑利旧申请单',
          en: '编辑利旧申请单_en',
          jp: '编辑利旧申请单_jp'
        },
        spmB: 'b441',
        i18nCode: 'requisition/edit',
        isNewHeader: true,
        menuCode: '/recycle/list'
      }
    }
  ],
  fluid: [
    // 我的领用单
    {
      path: '/requisition/list',
      name: 'requisitionList',
      component: () => import(/* webpackChunkName: "requisitionList" */'../routes/requisition/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的领用单',
          en: '我的领用单_en',
          jp: '我的领用单_jp'
        },
        spmB: 'b24',
        i18nCode: 'requisition/list',
        isNewHeader: true
      }
    },
    {
      path: '/recycle/list',
      name: 'recycleList',
      component: () => import(/* webpackChunkName: "recycleList" */'../routes/requisition/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的利旧单',
          en: '我的利旧单_en',
          jp: '我的利旧单_jp'
        },
        spmB: 'b442',
        i18nCode: 'requisition/list',
        isNewHeader: true
      }
    }
  ]
}
